import { translate } from "app/filters/i18nFilter";
import type { FC } from "react";
import type { ETypes } from "app/pages/industry-analysis/players/table/bubble-chart/types";
import { LegendBullet } from "@similarweb/ui-components";
import { FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";
import { DEFAULT_COLOR } from "app/pages/industry-analysis/players/table/bubble-chart/const";
import { ToggleFilter } from "pro-features/components/filtersPanel/src/ToggleFilter";
import { proNavigator } from "single-spa/react-app/ProNavigator";
import { getTrackingFilters } from "app/pages/industry-analysis/players/table/bubble-chart/utils";
import { allTrackers } from "app/services/track/track";

interface IActionButtons {
    type: ETypes;
    showAverage: boolean;
    setShowAverage: (showAverage: boolean) => void;
    showAvgUniqueUsers: boolean;
}

export const AverageToggle: FC<IActionButtons> = (props) => {
    const { type, showAverage, setShowAverage, showAvgUniqueUsers } = props;

    const onShowAverageClick = () => {
        const newShowAverage = !showAverage;
        const trackingFilters = getTrackingFilters(type, newShowAverage);
        allTrackers.dispatchTrackEvent("Button", "click", "IndustryAverage", trackingFilters);
        setShowAverage(newShowAverage);
        proNavigator.applyUpdateParamsAsync({
            bubbleChartShowAverage: newShowAverage,
        });
    };

    const bulletText = showAvgUniqueUsers
        ? "market.research.players.bubble.action.button.bubble.size.unique"
        : "market.research.players.bubble.action.button.bubble.size";

    return (
        <FlexRow>
            <LegendBullet
                text={translate(bulletText)}
                labelColor={DEFAULT_COLOR}
            />
            <ToggleFilter
                isActive={showAverage}
                onClick={onShowAverageClick}
                label={translate("market.research.players.bubble.action.buttons.show.average")}
                tooltip={translate("market.research.players.bubble.action.buttons.show.average.tooltip")}
            />
        </FlexRow>
    );
};
